import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgKgCardTypeSpotify = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 32,
	height: 32,
	viewBox: "0 0 32 32",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M16 .053C7.19.053.047 7.194.047 16.003c0 8.81 7.142 15.951 15.951 15.951 8.81 0 15.951-7.14 15.951-15.95C31.95 7.194 24.81.054 16 .054V.053zm7.314 23.005c-.285.469-.899.618-1.367.33-3.745-2.288-8.46-2.806-14.013-1.537-.535.122-1.068-.213-1.19-.749-.122-.535.212-1.068.748-1.19 6.076-1.389 11.288-.79 15.493 1.779.468.287.617.899.33 1.367zm1.953-4.343c-.36.585-1.126.77-1.71.41-4.288-2.636-10.824-3.4-15.896-1.86-.657.199-1.352-.172-1.552-.828-.198-.658.173-1.351.83-1.551 5.793-1.758 12.994-.907 17.918 2.12.585.36.77 1.125.41 1.709zm.167-4.523c-5.14-3.054-13.623-3.334-18.531-1.845-.788.24-1.622-.205-1.86-.994-.24-.788.205-1.621.994-1.86 5.634-1.711 15.001-1.38 20.92 2.133.71.42.943 1.336.522 2.044-.42.71-1.337.943-2.044.522z",
		fill: "#1ED760",
		fillRule: "nonzero"
	})
});
export default SvgKgCardTypeSpotify;
